import { Box, Typography } from '@mui/material'
import React from 'react'
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

function SmartInventory() {
  const features = [
    {
      icon: <AccessTimeIcon sx={{ fontSize: 40, color: "#fff" }} />,
      title: "Integrations",
    },
    {
      icon: <CheckCircleIcon sx={{ fontSize: 40, color: "#fff" }} />,
      title: "Management",
    },
    {
      icon: <AccessTimeIcon sx={{ fontSize: 40, color: "#fff" }} />,
      title: "Tracking",
    },
  ];
  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: "bold",mt:'2%', mb: "20px",justifyContent: 'center',alignItems:'center',textAlign: 'center' }}>
      Smart Inventory, Smarter<br/> Business
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          flexWrap: "wrap",
          padding: "20px",
          mt: "20px",
        }}
      >
        {features.map((feature, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              background: 'linear-gradient(145.08deg, #1678F2 3.73%, #65A8FB 132.69%)',
              borderRadius: "15px",
              padding: "10px",
              width: "200px",
              color: "#fff",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            {feature.icon}
            <Box>
              <Typography sx={{ fontSize: "15px", fontWeight: "bold" }}>
                {feature.title}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default SmartInventory